module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_3.5d29a95a.png";